import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';

export const useGetValidConfirmationForService = () => {
  const services = useSelector(Global.selectSellerServices);
  const carriers = useSelector(Global.selectReferenceDatagetSellerCarriers);

  const getValidConfirmationForService = useCallback(
    (serviceId, confirmationId) => {
      const foundService = services.find((service) => service.serviceId === serviceId);
      if (!foundService) {
        return confirmationId;
      }

      const carrierId = foundService.carrierId || '';
      const carrierInfo = carriers.find((carrier) => carrier.carrierId === carrierId);
      const carrierConfirmationTypes = carrierInfo?.confirmations || emptyArray;

      const matchingConfirmation = carrierConfirmationTypes.find((conf) => conf.confirmationId === confirmationId);
      // handle an edge case where carriers with a single confirmation that has a confirmationId !== 0 are not selectable in the UI
      if (carrierConfirmationTypes.length === 1 && !matchingConfirmation) {
        return carrierConfirmationTypes[0].confirmationId;
      }

      return confirmationId;
    },
    [services, carriers],
  );

  return getValidConfirmationForService;
};
